var MicroserviceModule = /** @class */ (function () {
    function MicroserviceModule() {
    }
    return MicroserviceModule;
}());
export { MicroserviceModule };
